import Loading from 'common/components/loading/loading';
import { NumberTile, TileData } from 'features/tiles/numberTile';
import Tile from 'features/tiles/tile';
import { FC } from 'react';
import {
  useGetMetricsQuery,
  CountResponse,
  useGetVisitorCountQuery
} from 'app/apis/queryApi';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import moment from 'moment';
import { getDateRangeAsObjects } from 'features/date-range-selection/dateRangeSlice';

const VisitorMetricTile: FC = () => {
  const dateRange = useSelector(getDateRangeAsObjects);

  const { siteId } = useSelector((state: RootState) => state.selectedSite);
  const {
    data: visitorData,
    isLoading: visitorIsLoading,
    isFetching: visitorIsFetching
  } = useGetVisitorCountQuery({
    siteId,
    startDate: moment(dateRange.startDate).format('DD/MM/YYYY'),
    endDate: moment(dateRange.endDate).format('DD/MM/YYYY')
  });

  const {
    data: allMetricsData,
    isLoading: allMetricsDataIsLoading,
    isFetching: allMetricsDataIsFetching
  } = useGetMetricsQuery({
    siteId,
    conversionFilter: 'All',
    startDate: moment(dateRange.startDate).format('DD/MM/YYYY'),
    endDate: moment(dateRange.endDate).format('DD/MM/YYYY')
  });

  const sumTileDataForDateRange = (tileData: CountResponse): number => {
    return Object.values(tileData).reduce((a, b) => a + b, 0);
  };

  const createTileMetricsValue = (
    visitorDataTotal: number,
    metricDataTotal: number
  ): number => {
    const metric = (metricDataTotal / visitorDataTotal) * 100;
    return Number(metric.toFixed(2));
  };

  const getDataForTile = (
    tileTitle: string,
    data: CountResponse[],
    metricData: CountResponse,
    locales: string,
    formatOptions: Intl.NumberFormatOptions
  ): TileData => {
    if (visitorData === undefined) {
      return {
        label: tileTitle,
        count: 0,
        metric: '',
        format: Intl.NumberFormat(locales)
      };
    }
    const total = sumTileDataForDateRange(data[0]);
    const visitorTotal = sumTileDataForDateRange(visitorData);
    const metricTotal = sumTileDataForDateRange(metricData);
    const metricValue = createTileMetricsValue(visitorTotal, metricTotal);

    return {
      label: tileTitle,
      count: total,
      metric: `${metricValue}% Converted to lead`,
      format: Intl.NumberFormat(locales)
    };
  };
  return (
    <>
      <Tile className="w-full">
        {!visitorIsLoading &&
        !allMetricsDataIsLoading &&
        !visitorIsFetching &&
        !allMetricsDataIsFetching &&
        visitorData != null &&
        allMetricsData != null ? (
          <NumberTile
            tileData={getDataForTile(
              'Visitors',
              [visitorData],
              allMetricsData,
              'en-GB',
              {}
            )}
          />
        ) : (
          <Loading />
        )}
      </Tile>
    </>
  );
};

export default VisitorMetricTile;
